module.exports = __webpack_public_path__ + "static/media/orthodox-faith-and-life.5f54a574.jpg";